import axios from "axios";

const baseURL = "https://www.pentagov.com.br/api";
const SESSION_EXPIRED_MESSAGE = "Sua sessão expirou. Faça login novamente.";

const api = axios.create({
    //baseURL: "http://192.168.56.1:3002",
    //baseURL: "http://192.168.14.101:3001",
    //baseURL: "http://192.168.14.100:3001",
    baseURL,
    //baseURL: "http://192.168.14.100:3001",
    // baseURL: "https://www.pentagov.com.br/api",
});

const refreshApi = axios.create({ baseURL });

let isRefreshing = false;
let failedQueue = [];
let sessionExpiredHandled = false;

const publicRoutes = [
    { path: "/auth/login", method: "post" },
    { path: "/auth/refresh", method: "post" },
    { path: "/recuperarsenha" },
    { path: "/operadorsenha", method: "put" },
    { path: "/cadOperadorExterno", method: "post", exact: true },
];

const normalizeUrlPath = (url = "") => {
    try {
        return new URL(url, baseURL).pathname;
    } catch {
        return url;
    }
};

const isPublicRoute = (url = "", method = "") => {
    const path = normalizeUrlPath(url);
    const requestMethod = method.toLowerCase();

    return publicRoutes.some((route) => {
        const methodMatches = !route.method || route.method === requestMethod;
        const pathMatches = route.exact ? path === route.path : path === route.path || path.startsWith(`${route.path}/`);

        return methodMatches && pathMatches;
    });
};

const processQueue = (error, token = null) => {
    failedQueue.forEach(({ resolve, reject }) => {
        if (error) {
            reject(error);
        } else {
            resolve(token);
        }
    });

    failedQueue = [];
};

const removeAuthorizationHeader = (headers) => {
    if (!headers) return;

    if (typeof headers.delete === "function") {
        headers.delete("Authorization");
        headers.delete("authorization");
        return;
    }

    delete headers.Authorization;
    delete headers.authorization;
};

const setAuthorizationHeader = (headers, token) => {
    if (!headers) return;

    if (typeof headers.set === "function") {
        headers.set("Authorization", `Bearer ${token}`);
    } else {
        headers.Authorization = `Bearer ${token}`;
    }
};

const redirectToLogin = () => {
    if (sessionExpiredHandled) return;

    sessionExpiredHandled = true;
    localStorage.clear();
    localStorage.setItem("toastLogout", SESSION_EXPIRED_MESSAGE);
    window.location.href = "/";
};

api.interceptors.request.use((config) => {
    config.headers = config.headers || {};

    if (isPublicRoute(config.url, config.method)) {
        removeAuthorizationHeader(config.headers);
        return config;
    }

    const token = localStorage.getItem("authToken");
    if (token) {
        setAuthorizationHeader(config.headers, token);
    }

    return config;
});

api.interceptors.response.use((response) => response, async (error) => {
    const originalRequest = error.config;

    if (!originalRequest || error.response?.status !== 401) {
        return Promise.reject(error);
    }

    //Token Expirado
    if (originalRequest._retry || isPublicRoute(originalRequest.url, originalRequest.method) || normalizeUrlPath(originalRequest.url).includes("/auth/refresh")) {
        return Promise.reject(error);
    }

    const refreshToken = localStorage.getItem("refreshToken");

    if (!refreshToken) {
        redirectToLogin();
        return Promise.reject(error);
    }

    if (isRefreshing) {
        return new Promise((resolve, reject) => {
            failedQueue.push({ resolve, reject });
        }).then((token) => {
            originalRequest._retry = true;
            originalRequest.headers = originalRequest.headers || {};
            setAuthorizationHeader(originalRequest.headers, token);
            return api(originalRequest);
        });
    }

    originalRequest._retry = true;
    isRefreshing = true;

    try {
        const response = await refreshApi.post("/auth/refresh", { refreshToken });
        const newToken = response.data.token;

        if (!newToken) {
            throw new Error("Refresh sem token");
        }

        localStorage.setItem("authToken", newToken);
        setAuthorizationHeader(api.defaults.headers.common, newToken);
        originalRequest.headers = originalRequest.headers || {};
        setAuthorizationHeader(originalRequest.headers, newToken);
        processQueue(null, newToken);

        return api(originalRequest);
    } catch (refreshError) {
        processQueue(refreshError, null);
        redirectToLogin();
        return Promise.reject(refreshError);
    } finally {
        isRefreshing = false;
    }
});

export default api;
